module.exports = __webpack_public_path__ + "static/media/facebook-black.89c123d5.svg";